import { createRoute } from "@tanstack/react-router";

import { lazyWithRetry } from "@shared/lib/lazy";

import { renderProtectedRoute } from "@app/router/routeElements";
import { rootRoute } from "@app/router/rootRoute";

const gettingStartedIndex = lazyWithRetry(() => import("./routes/index"));

const gettingStartedRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/getting-started",
  beforeLoad: () => ({
    breadcrumbs: [
      { label: "Dashboard", to: "/dashboard" },
      { label: "Getting Started" },
    ],
  }),
  component: () => renderProtectedRoute(gettingStartedIndex),
});

export const gettingStartedRouteTree = [gettingStartedRoute];
